import { createIcon } from "../create-icon"

export const FileDefaultIcon = createIcon({
  title: "FileDefaultIcon",
  viewBox: "0 0 16 20",
  path: (
    <>
      <mask
        id="mask0_970_1559"
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="12"
        height="16"
      >
        <path
          d="M2.82759 2H10.5075C10.6166 2 10.7213 2.04502 10.7988 2.12526L13.8775 5.31335C13.9559 5.39456 14 5.50515 14 5.62052V17.1351C14 17.6128 13.6295 18 13.1724 18H2.82759C2.37052 18 2 17.6128 2 17.1351V2.86486C2 2.38721 2.37052 2 2.82759 2Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_970_1559)">
        <path
          d="M2.82759 2H10.5075C10.6166 2 10.7213 2.04502 10.7988 2.12526L13.8775 5.31335C13.9559 5.39456 14 5.50515 14 5.62052V17.1351C14 17.6128 13.6295 18 13.1724 18H2.82759C2.37052 18 2 17.6128 2 17.1351V2.86486C2 2.38721 2.37052 2 2.82759 2Z"
          fill="#1E6FFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6777 2H13.9881V5.24324H11.5053C11.0483 5.24324 10.6777 4.88023 10.6777 4.43243V2Z"
          fill="#99BEFF"
        />
      </g>
      <path
        d="M10.9167 8H5.08333C4.6231 8 4.25 8.33579 4.25 8.75C4.25 9.16421 4.6231 9.5 5.08333 9.5H10.9167C11.3769 9.5 11.75 9.16421 11.75 8.75C11.75 8.33579 11.3769 8 10.9167 8Z"
        fill="white"
      />
      <path
        d="M8.625 11H5.125C4.64175 11 4.25 11.3358 4.25 11.75C4.25 12.1642 4.64175 12.5 5.125 12.5H8.625C9.10825 12.5 9.5 12.1642 9.5 11.75C9.5 11.3358 9.10825 11 8.625 11Z"
        fill="white"
      />
    </>
  ),
})

FileDefaultIcon.displayName = "FileDefaultIcon"
